import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";
import { toast } from "sonner";
import { LogIn, AlertCircle } from "lucide-react";

const AdminLogin = () => {
  const { admin, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (!loading && admin) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim() || !password) {
      setError("Имэйл болон нууц үг шаардлагатай");
      return;
    }
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast.success("Тавтай морилно уу, Админ!");
      navigate("/admin", { replace: true });
    } catch (err) {
      const status = err?.response?.status;
      const detail = err?.response?.data?.detail;
      let msg;
      if (status === 401) {
        msg = "Имэйл эсвэл нууц үг буруу байна";
      } else if (typeof detail === "string") {
        msg = detail;
      } else if (err?.message === "Network Error") {
        msg = "Сүлжээний алдаа — серверт холбогдох боломжгүй байна";
      } else {
        msg = "Нэвтрэхэд алдаа гарлаа. Дахин оролдоно уу.";
      }
      setError(msg);
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="bg-[#FBF9F6] border border-[#B8860B]/30 rounded-2xl shadow-lg p-8">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="Дарьганга зээрднүүд" className="h-20 w-auto object-contain mx-auto mb-3" />
          <h1 className="text-2xl font-bold text-[#1B3B5A]">Админ нэвтрэх</h1>
          <p className="text-sm text-[#5C4F42] mt-2">Дарьганга зээрднүүд — удирдлагын хэсэг</p>
        </div>

        {error && (
          <div
            className="mb-4 flex items-start gap-2 bg-[#FEE2E2] border border-[#FCA5A5] text-[#8B2500] rounded-md px-3 py-2 text-sm"
            role="alert"
            data-testid="login-error"
          >
            <AlertCircle size={16} className="mt-0.5 shrink-0" strokeWidth={2} />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form" noValidate>
          <div>
            <label className="text-sm font-bold text-[#5C4F42] mb-1 block">Имэйл</label>
            <input
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); if (error) setError(""); }}
              autoComplete="username"
              required
              className="w-full bg-white border border-[#D6CFC4] rounded-md px-4 py-2.5 focus:outline-none focus:border-[#B8860B]"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="text-sm font-bold text-[#5C4F42] mb-1 block">Нууц үг</label>
            <input
              type="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); if (error) setError(""); }}
              autoComplete="current-password"
              required
              className="w-full bg-white border border-[#D6CFC4] rounded-md px-4 py-2.5 focus:outline-none focus:border-[#B8860B]"
              data-testid="login-password"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#1B3B5A] text-white hover:bg-[#264F78] disabled:opacity-60 px-6 py-3 rounded-lg font-bold transition-colors"
            data-testid="login-submit"
          >
            <LogIn size={16} strokeWidth={1.5} />
            {submitting ? "Нэвтэрч байна..." : "Нэвтрэх"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
